<template>
    <!-- **TODO Might want to try to grab token at time of allow push switch to prevent blank on first load.-->
        <v-dialog v-model="showDialog" max-width="350">
            <v-card
                title="Notification Settings"
                v-if="token != ''" class="mx-auto pb-0 px-0"
            >
                <v-card-text>
                    <v-row>
                        <v-col class="d-flex align-center py-0">
                            <v-card-subtitle class="pl-0 py-0">Allow Push Notifications to Device</v-card-subtitle>
                            <v-switch
                                v-model="notif_allowed"
                                color="primary"
                                false-value="0"
                                true-value="1"
                                hide-details
                            ></v-switch>
                        </v-col>
                    </v-row>
                    <div v-if="notif_allowed == 1">
                        <v-row class="justify-center pb-4">
                            <v-col cols="12">
                                <v-select
                                    label="Receive Notifications For"
                                    :items="notif_options"
                                    v-model="tier_chosen"
                                    item-title="name"
                                    item-value="tier"
                                    variant="solo-filled"
                                    hide-details
                                    ></v-select>
                                    <!-- @update:model-value="filterTier" -->
                            </v-col>
                            <v-col cols="12">
                                <v-radio-group class="pa-0 ma-0" inline v-model="tier_frequency" name="tier3" label="Frequency" hide-details>
                                    <v-radio label="All" color="primary" value="all"></v-radio>
                                    <v-radio label="Hourly" color="primary" value="hour"></v-radio>
                                    <v-radio label="Daily" color="primary" value="day"></v-radio>
                                    <!-- <v-radio label="None" color="primary" value="tier3_none"></v-radio> -->
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12">
                                <!-- Using a select below Due to the time picker currently being in a labs/experimental part of Vue 3, and it could therefore be changed later. Plus I think just having it in increments of 1 hour is best. -->
                                <v-select
                                    label="Do Not Disturb Start Time"
                                    :items="time_options"
                                    v-model="dnd_start"
                                    item-title="name"
                                    item-value="value"
                                    variant="solo-filled"
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <!-- Using a select below Due to the time picker currently being in a labs/experimental part of Vue 3, and it could therefore be changed later. Plus I think just having it in increments of 1 hour is best. -->
                                <v-select
                                    label="Do Not Disturb End Time"
                                    :items="time_options"
                                    v-model="dnd_end"
                                    item-title="name"
                                    item-value="value"
                                    variant="solo-filled"
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>
                        <!-- <v-btn>
                            <v-icon>mdi-bell-off</v-icon>
                            <span>Disable Notifications</span>
                        </v-btn> -->
                        <!-- <v-divider></v-divider>
                        <h3>Token: {{ token }}</h3>
                        <v-btn @click="testBtn" >Test</v-btn> -->
                        <!-- <h3>Message Title: {{ messageTitle }}</h3>
                        <h3>Message Text: {{ messageText }}</h3> -->
                        <!-- <v-divider pb-4></v-divider> -->
                    </div>
                    <v-row class="justify-center pb-2">
                        <v-btn class="rounded-xl white--text px-12" color="#1ac266" @click="saveSettings">Save Settings</v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    <v-btn class="rounded-xl white--text" color="#1ac266" @click="openSettings">
        <!-- <v-icon>mdi-bell</v-icon> -->
        <span>Notification Settings</span>
    </v-btn>
</template>
    
<script>
import { getMessaging, getToken } from "firebase/messaging";
import fb from '../fb.js';
// import axios from 'axios';
import { useMainStore } from '@/store/store';
import { mapState, mapWritableState } from 'pinia';
import { toRaw, nextTick } from "vue";

export default {
    setup() {
    const store = useMainStore()
    
    // function setAccess(value){
    //   userAccessLevel.value = value
    // }

    return { 
      store,
     }
  },
    data(){
        return {
            time: null,
            token: '',
            tier4_option: 'tier4_none',
            tier3_option: 'tier3_none',
            tier_frequency: 'hour',
            dnd_start: null,
            dnd_end: null,
            showDialog: false,
            toRawUser: [],
            notif_allowed: 0, // get the setting from the user
            notif_options: [
                // { name: 'All', tier: '0', },
                { name: 'Subdued and Higher', tier: '1' },
                { name: 'Engaging and Higher', tier: '2' },
                { name: 'Vivid and Higher', tier: '3', },
                { name: 'Brilliant', tier: '4', },
            ],
            time_options: [
                { name: 'None', value: null, },
                { name: '12 PM', value: '12', },
                { name: '1 PM', value: '13', },
                { name: '2 PM', value: '14', },
                { name: '3 PM', value: '15', },
                { name: '4 PM', value: '16', },
                { name: '5 PM', value: '17', },
                { name: '6 PM', value: '18', },
                { name: '7 PM', value: '19', },
                { name: '8 PM', value: '20', },
                { name: '9 PM', value: '21', },
                { name: '10 PM', value: '22', },
                { name: '11 PM', value: '23', },
                { name: '12 AM', value: '0', },
                { name: '1 AM', value: '1', },
                { name: '2 AM', value: '2', },
                { name: '3 AM', value: '3.5', },
                { name: '4 AM', value: '4', },
                { name: '5 AM', value: '5', },
                { name: '6 AM', value: '6', },
                { name: '7 AM', value: '7', },
                { name: '8 AM', value: '8', },
                { name: '9 AM', value: '9', },
                { name: '10 AM', value: '10', },
                { name: '11 AM', value: '11', },

            ],
            
            tier_chosen: '1',
            dnd_dialog_end: false,
            dnd_dialog_start: false,
            current_settings: {},
        }
    },
    computed: {
        // noAccessRefirect() {
        //     return this.user.status >= 5
        // },
        ...mapState(useMainStore, {
            user: store => store.user,
            isLoggedIn: store => store.isLoggedIn,
            notif_settings: store => store.notif_settings,
        }),
        ...mapWritableState(useMainStore, {
            // notif_settings: store => store.notif_settings,
        }),
    },
    methods:{
        //**TODO** This should get the token, then also save it to the database if it does not exist.
        //**TODO** This should also be saved to the users local storage so that they do not need to click this every time they load the page.
        async openSettings(){
            // console.log("Opening Notification Settings")
            // this.notif_allowed = this.toRawUser.notif_allowed
            if (!("Notification" in window)) {
                // Check if the browser supports notifications
                alert("This browser does not support notifications");
            }
            else if (Notification.permission === "denied") {
                // If the user has denied notifications previously, they need to change this in their browser settings
                alert("You have blocked notifications. Please enable them in your browser settings to manage notification settings.");
                return
            }
            else if (Notification.permission === "granted") {
                // Check whether notification permissions have already been granted;
                // console.log("Permission already granted")
            } else if (Notification.permission !== "denied") {
                // We need to ask the user for permission
                Notification.requestPermission().then((permission) => {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    // console.log("Permission now granted!")
                }
                });
            }
            this.messaging = getMessaging(fb)
            if(this.messaging){
            try {
                // console.log("2")
                await getToken(this.messaging, { vapidKey: "BBaFCQ_NrGLHNo4ULInXKxl7kxWUyygfaxebeFYP2PaRRxYTMu17cPY-tKH2UMWdM3YIwe-5lVvrc0LK-a8BJII",})
                .then((currentToken) => {
                if (currentToken) {
                    // console.log("Token:", currentToken)
                    this.token = currentToken
                    // **TODO** check if the token exists in the database, if it does, then load the users settings.
                    this.getNotifSettings(this.token)
                    .then(() => {
                        this.showDialog = true
                    })
                    // this.showDialog = true
                } else {
                    // Something whent wrong with firebase. Might want to log this in DB for further investigation.
                    this.token = "No token available"
                    // console.log("No token available")
                    // alert("You must allow notifications in your browser to edit notification settings.")
                }
                })
            } catch(err) {
                // console.log('Error: ', err)
                this.token = err
            }
            }
        },
        async saveSettings(){
            //**TODO** This will save the users notification settings to the database. Update to new system
            // let data = {
            //     notif_allowed: this.notif_allowed,
            //     token: this.token,
            //     tier_chosen: this.tier_chosen,
            //     dnd_start: this.dnd_start,
            //     dnd_end: this.dnd_end,
            // }
            let fixed_start = ''
            let fixed_end = ''
            let tmp_date1 = new Date()
            // let tmp_date2 = new Date()
            // let offsetMinutes = tmp_date1.getTimezoneOffset();
            let offsetMinutes = (tmp_date1.getTimezoneOffset());
            let offsetHours = offsetMinutes / 60;
            // console.log("Offset Hours:", offsetHours)
            // console.log("Offset minites:", offsetMinutes)
            
            let offsetMinsValue = 0
            let tstval = offsetMinutes
            let tstval2 = 0
            // let offsetMins = 0;
            if(tstval % 60 != 0){
                // Gets the minite value of the timezone incase timezone causes non whole hour offset
                offsetMinsValue = tstval % 60;
                // console.log("offset mins:", offsetMinsValue)
                tstval2 = offsetMinutes - offsetMinsValue
                offsetHours = tstval2 / 60;
            }
            // console.log("final value: " +  offsetHours + ":" + offsetMinsValue +":00")

            // console.log("Offset Mins:", offsetMinutes)
            // console.log("divisible:", offsetMinutes % 60)
            // console.log("divisible test:", tstval % 60)
            // This whole thing is not super flexable... Should prbs just rething and make more granular yet controllable system...
            // I guess for now just get hours, more up/down for offset, then round to nearest whole number
            if (this.dnd_start !== null) {
                // tmp_date1.setHours(this.dnd_start, 0, 0) //will set to 4 am UTC
                if((parseInt(this.dnd_start) + offsetHours) > 23){
                    let start_hours = (parseInt(this.dnd_start) + offsetHours) - 24
                    let string_start = String(start_hours)
                    if(start_hours < 10){
                        string_start = "0" + String(start_hours)
                    }
                    fixed_start = "" + string_start + ":" + String(offsetMinsValue) + ":00"
                } else if ((parseInt(this.dnd_start) + offsetHours) < 0){
                    // fixed_start = (parseInt(this.dnd_start) + offsetHours) + 24
                    let start_hours = (parseInt(this.dnd_start) + offsetHours) + 24
                                        let string_start = String(start_hours)
                    if(start_hours < 10){
                        string_start = "0" + String(start_hours)
                    }
                    fixed_start = "" + String(string_start) + ":" + String(offsetMinsValue) + ":00"
                } else {
                    // fixed_start = parseInt(this.dnd_start) + offsetHours
                    let start_hours = parseInt(this.dnd_start) + offsetHours
                                        let string_start = String(start_hours)
                    if(start_hours < 10){
                        string_start = "0" + String(start_hours)
                    }
                    fixed_start = "" + String(string_start) + ":" + String(offsetMinsValue) + ":00"
                }
            }
            if (this.dnd_end !== null) {
                // console.log("End:", this.dnd_end)
                // console.log("Added:", parseInt(this.dnd_end) + offsetHours) 
                // tmp_date2.setHours(this.dnd_end, 0, 0) //will set to 4 am UTC
                if((parseInt(this.dnd_end) + offsetHours) > 23){
                    let end_hours = (parseInt(this.dnd_end) + offsetHours) - 24
                    let string_end = String(end_hours)
                    if(end_hours < 10){
                        string_end = "0" + String(end_hours)
                    }
                    fixed_end = "" + String(string_end) + ":" + String(offsetMinsValue) + ":00"
                    // console.log("over")
                } else if ((parseInt(this.dnd_end) + offsetHours) < 0){
                    // fixed_end = (parseInt(this.dnd_end) + offsetHours) + 24
                    let end_hours = (parseInt(this.dnd_end) + offsetHours) + 24
                    let string_end = String(end_hours)
                    if(end_hours < 10){
                        string_end = "0" + String(end_hours)
                    }
                    fixed_end = "" + String(string_end) + ":" + String(offsetMinsValue) + ":00"
                    // console.log("under")
                } else {
                    // fixed_end = parseInt(this.dnd_end) + offsetHours
                    let end_hours = parseInt(this.dnd_end) + offsetHours
                    let string_end = String(end_hours)
                    if(end_hours < 10){
                        string_end = "0" + String(end_hours)
                    }
                    fixed_end = "" + String(string_end) + ":" + String(offsetMinsValue) + ":00"
                    // console.log("normal")
                }
            }else if(this.dnd_end === null && this.dnd_start !== null){
                fixed_end = '18:00:00' //default to 6 pm if only start is set
            }

            let chosen = "tier_" + this.tier_chosen
            let frequency = '2'
            switch (this.tier_frequency) {
                case "day":
                    frequency = '3'
                    break;
            
                case "hour":
                    frequency = '2'
                    break;

                case "all":
                    frequency = '1'
                    break;
            
                default:
                    frequency = '3'
                    break;
            }

            let data = {
                notif_allowed: this.notif_allowed,
                token: this.token,
                tier_chosen: chosen,
                tier_frequency: frequency,
                dnd_start: fixed_start,
                dnd_end: fixed_end,
            }
            // console.log(offsetHours)
            // console.log('Saving settings:', data)

            // axios.post('update_notif_settings', data)
            // **TODO** This should return a message to the user that the settings were saved successfully.
            await this.store.updateNotifsettings(data)
            .then(() => {
                // this.messageTitle = response.data.title
                // this.messageText = response.data.message
                // console.log(response.data)
                this.showDialog = false
            });

        },
        // **TODO Update this with new tiers
        async getNotifSettings(currentToken){
            // console.log("Token:", currentToken)
            //Gets fresh values from the store
            this.store.$reset()
            // this.toRawUser = toRaw(this.user)
            // await nextTick()
            
            await this.store.getNotifSettings(currentToken)
            .then(() => {
                this.notif_allowed = this.notif_settings.notif_allowed
                // console.log(JSON.parse(JSON.stringify(this.notif_settings)))
                // console.log(this.notif_settings.tier_4)
                // this.current_settings = (JSON.parse(JSON.stringify(this.notif_settings)))
                // console.log(this.current_settings)
                this.tier_chosen = this.notif_settings.tier
                if(this.notif_settings.tier == '0'){
                    this.tier_chosen = '4'
                }
                // check tier chosen
                // switch ("2") {
                //     case this.notif_settings.tier_4:
                //         this.tier_chosen = '4'
                //         break;
                
                //     case this.notif_settings.tier_3:
                //         this.tier_chosen = '3'
                //         break;
                
                //     case this.notif_settings.tier_2:
                //         this.tier_chosen = '2'
                //         break;

                //     case this.notif_settings.tier_1:
                //         this.tier_chosen = '1'
                //         break;

                //     default:
                //         this.tier_chosen = 'None'
                //         break;
                // }
                // if(this.tier_chosen == 'None'){
                //     switch ("1") {
                //         case this.notif_settings.tier_4:
                //             this.tier_chosen = '4'
                //             break;
                    
                //         case this.notif_settings.tier_3:
                //             this.tier_chosen = '3'
                //             break;
                    
                //         case this.notif_settings.tier_2:
                //             this.tier_chosen = '2'
                //             break;

                //         case this.notif_settings.tier_1:
                //             this.tier_chosen = '1'
                //             break;

                //         default:
                //             this.tier_chosen = '4'
                //             break;
                //     }
                // }
                // check frequency
                switch (this.notif_settings.frequency) {
                    case "3":
                        this.tier_frequency = 'day'
                        break;
                
                    case "2":
                        this.tier_frequency = 'hour'
                        break;

                    case "1":
                        this.tier_frequency = 'all'
                        break;
                    // user has no setting saved, set to hourly by default
                    default:
                        this.tier_frequency = 'hour'
                        break;
                }

                // console.log(this.tier4_option)
                // console.log(this.tier3_option)
            })
        },
        // Can use this to update last visit date to prevent stale tokens
        checkNotifPerms() {
                // console.log("persmission: ", Notification.permission); // granted, denied, default are states of this

                // Notif Perms already granted, so can load/create firebase token
            if (Notification.permission == "granted") {
                this.messaging = getMessaging(fb)

                getToken(this.messaging, { vapidKey: "BBaFCQ_NrGLHNo4ULInXKxl7kxWUyygfaxebeFYP2PaRRxYTMu17cPY-tKH2UMWdM3YIwe-5lVvrc0LK-a8BJII",})
                .then((currentToken) => {
                if (currentToken) {
                    // console.log("3")
                    this.token = currentToken
                    // console.log("Token:", currentToken)
                    // **TODO** check if the token exists in the database, if it does, then load the users settings.
                    // this.getNotifSettings(this.token)
                    // .then(() => {
                    //     console.log("4")
                    //     this.showDialog = true
                    // })
                    // this.showDialog = true
                }
                // else {
                //     // **TODO** display msg that you must accept notifications to edit the settings
                //     this.token = "No token available"
                //     // console.log("No token available")
                // }
                })

            }
        },
        // async getNotifSettings(currentToken){
        //     // console.log("Token:", currentToken)
        //     //Gets fresh values from the store
        //     this.store.$reset()
        //     this.toRawUser = toRaw(this.user)
        //     await nextTick()
        //     this.notif_allowed = this.toRawUser.notif_allowed

        //     await this.store.getNotifSettings(currentToken)
        //     .then(() => {
        //         // console.log(JSON.parse(JSON.stringify(this.notif_settings)))
        //         switch ("2") {
        //             case this.notif_settings.tier4_all:
        //                 this.tier4_option = 'tier4_all'
        //                 break;
                
        //             case this.notif_settings.tier4_day:
        //                 this.tier4_option = 'tier4_day'
        //                 break;
                
        //             case this.notif_settings.tier4_hour:
        //                 this.tier4_option = 'tier4_hour'
        //                 break;

        //             default:
        //                 this.tier4_option = 'tier4_none'
        //                 break;
        //         }
        //         if(this.tier4_option == 'tier4_none'){
        //         switch ("1") {
        //             case this.notif_settings.tier4_all:
        //                 this.tier4_option = 'tier4_all'
        //                 break;
                
        //             case this.notif_settings.tier4_day:
        //                 this.tier4_option = 'tier4_day'
        //                 break;
                
        //             case this.notif_settings.tier4_hour:
        //                 this.tier4_option = 'tier4_hour'
        //                 break;

        //             default:
        //                 this.tier4_option = 'tier4_none'
        //                 break;
        //         }
        //         }
        //         switch ("2") {
        //             case this.notif_settings.tier3_all:
        //                 this.tier3_option = 'tier3_all'
        //                 break;
                
        //             case this.notif_settings.tier3_day:
        //                 this.tier3_option = 'tier3_day'
        //                 break;
                
        //             case this.notif_settings.tier3_hour:
        //                 this.tier3_option = 'tier3_hour'
        //                 break;

        //             default:
        //                 this.tier3_option = 'tier3_none'
        //                 break;
        //         }
        //         if(this.tier3_option == 'tier3_none'){
        //         switch ("1") {
        //             case this.notif_settings.tier3_all:
        //                 this.tier3_option = 'tier3_all'
        //                 break;
                
        //             case this.notif_settings.tier3_day:
        //                 this.tier3_option = 'tier3_day'
        //                 break;
                
        //             case this.notif_settings.tier3_hour:
        //                 this.tier3_option = 'tier3_hour'
        //                 break;

        //             default:
        //                 this.tier3_option = 'tier3_none'
        //                 break;
        //         }
        //         }
        //         // console.log(this.tier4_option)
        //         // console.log(this.tier3_option)
        //     })
        // },
        // testBtn(){
        //     // console.log('Test button clicked')
        //     axios.defaults.baseUrl = this.$apiEndpointUrl;

        //     let data = {
        //         registration_token: this.token,
        //         topic: "tier4",
        //     }

        //     axios.post('test_subscribe', data)
        //     .then(response => {
        //         // this.messageTitle = response.data.title
        //         // this.messageText = response.data.message
        //         console.log(response.data)
        //     });
        // }
    },
    async mounted(){
        // check the user account to see if notifications are allowed and set that value
        this.toRawUser = toRaw(this.user)
        await nextTick()
        // this.notif_allowed = this.toRawUser.notif_allowed

        this.checkNotifPerms()
    }
}

</script>

<style>

</style>